<template>
    <div id='captura'>
    <br>
        <div class="tile is-ancestor">
          <div class="tile is-vertical is-8">
            <div class="tile">
              <div class="tile is-parent is-vertical">
                <article class="tile is-child notification is-primary">
                  <p class="title">Controle sus cobros</p>
                  <p class="subtitle">Alertas oportunas</p>
                    <p>De moroso </p>
                    <p>De los que no pagaron nada este mes</p>
                    <p>De vencimiento de contrato</p>
                    <p>De desocupados</p>
                    <p>Reciba alertas a su mail, o a su app</p>
                    <p>App de control</p>

            </article>
                <article class="tile is-child notification is-warning">
                  <p class="title">Beneficios</p>
                  <p class="subtitle">Para su empresa</p>
                    <p>Reportes personalizados</p>
                    <p>Formateador personalizado</p>
                    <p>Consultas con busqueda avanzada</p>
                    <p>Contratos y pre-contratos</p>
                    <p>Estados de cuenta a mails, en consulta o pdf</p>
                    <p>Renovacion de contrato oportuno</p>
                    <p>Tips expertos para rentar, para cobrar y renovar</p>
                    <p>Sugerencias de renovaciones de contratos</p>
                    <p>Facilidad para argos de otros servicios</p>
                    <p>Configure usuarios con diferente nivel de autorizaciones</p>
                    <p>Capture de forma simple sus cobros</p>
                    <p>Acceso a whatsapp de inquilinos inmediato</p>
                    <p>Soporte continuo y profesional</p>


                </article>
              </div>
              <div class="tile is-parent">
                <article class="tile is-child notification is-info">
                  <p class="title">Control total</p>
                  <p class="subtitle">Integral</p>
                  
                  <figure class="image is-4by3">
                    <img src="https://www.directodo.com/Rentus/recursos/EDIFICIOS.jpg">
                  </figure>
                    <br>
                    <p>Descanse, todo bajo control</p>

                </article>
              </div>
            </div>
                          

            <div class="tile is-parent">
              <article class="tile is-child notification is-danger">
                <p class="title">Contacto</p>
                <p class="subtitle">24 hrs</p>
                <div class="content">
                    <span>
                        <a mailto:>
                            {{eMailVentas}}
                        </a>
                    </span>&nbsp&nbsp&nbsp&nbsp
                    <span>
                        <a  v-bind:href="'http://wa.me/521' + wVentas"  target = "_blank" >
                            <i class="fab fa-whatsapp fa-2x"></i>
                        </a>
                    </span>
                </div>
              </article>
            </div>
          </div>
          <div class="tile is-parent">
            <article class="tile is-child notification is-success">
              <div class="content">
                <p class="title">Precios</p>
                <p class="subtitle">Pago mensual</p>
                <div class="content">

                    <form action="https://www.paypal.com/cgi-bin/webscr" method="post" target="_top">          
                        <input type="hidden" name="cmd" value="_s-xclick">
                        <input type="hidden" name="hosted_button_id" value="AVYN2N8GF2TBY">
                        <table>
                        <tr><td><input type="hidden" name="on0" value="Número de inmuebles">Número de inmuebles</td></tr><tr><td><select name="os0">
                            <option value="Hasta 3">Hasta 3 $960.00 MXN</option>
                            <option value="Hasta 10">Hasta 10 $3,300.00 MXN</option>
                            <option value="Hasta 30">Hasta 30 $6,600.00 MXN</option>
                            <option value="Ilimitado">Ilimitado $13,200.00 MXN</option>
                        </select> </td></tr>
                        <tr><td><input type="hidden" name="on1" value="Su email de contacto">Su email de contacto</td></tr><tr><td><input type="text" name="os1" maxlength="200"></td></tr>
                        <tr><td><input type="hidden" name="on2" value="Su nombre o de la empresa">Su nombre o de la empresa</td></tr><tr><td><input type="text" name="os2" maxlength="200"></td></tr>
                        </table>
                        <input type="hidden" name="currency_code" value="MXN">
                        <input type="image" src="https://www.paypalobjects.com/es_XC/MX/i/btn/btn_buynowCC_LG.gif" border="0" name="submit" alt="PayPal, la forma más segura y rápida de pagar en línea.">
                        <img alt="" border="0" src="https://www.paypalobjects.com/es_XC/i/scr/pixel.gif" width="1" height="1">
                    </form>

                </div>
              </div>
            </article>
          </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    export default{
            name:'agrega-inquilino',
            props: ['vector', 'elusuario'],  
            data(){
                return {
                    inquilinos:{
                        nombreCompleto:'',
                        email:'',
                        celular:'',
                        telefonoFijo:'',
                        whatsapp:'',
                        facebook:'',
                        dirCalle:'',
                        dirNumero:'',
                        dirInterior:'',
                        dirColonia:'',
                        dirCodigo:'',
                        dirCiudad:'',
                        dirEstado:'',
                        status:'',
                        fechaModifica:'',
                        quienModifico:''
                        },
                    wVentas: "4423226293",
                    eMailVentas: "rentusqro@gmail.com"
                };
            },
            methods:{
                
                guardarInquilino(){
                    var inquilinos1= this.inquilinos;
                    var router= this.$router;

                    axios.post('https://www.directodo.com/Rentus/accesosdb/agregaInquilino.php?nombreCompleto='+inquilinos1.nombreCompleto+'&email='+inquilinos1.email+'&celular='+inquilinos1.celular+'&telefonoFijo='+inquilinos1.telefonoFijo+'&whatsapp='+inquilinos1.whatsapp+'&facebook='+inquilinos1.facebook+'&dirCalle='+inquilinos1.dirCalle+'&dirNumero='+inquilinos1.dirNumero+'&dirInterior='+inquilinos1.dirInterior+'&dirColonia='+inquilinos1.dirColonia+'&dirCodigo='+inquilinos1.dirCodigo+'&dirCiudad='+inquilinos1.dirCiudad+'&dirEstado='+inquilinos1.dirEstado+'&status=A'+'&fechaModifica='+this.fechaActual()+'&quienModifico='+ this.elusuario)
                          .then((respue) => {
                                if (respue.statusText == 'OK'){
                                    router.push('/inq')
                                }
                          })
                          .catch((error) =>{
                                console.log(error);
                          });
                },

                fechaActual(){      
                    var currentDate = new Date() //hoy
                    var day = currentDate.getDate();
                    var month = currentDate.getMonth() + 1;
                    var year = currentDate.getFullYear();
                    var my_date = year+"-"+month+"-"+day;
                    return my_date;    
                }

            }
    }
</script>


// WEBPACK FOOTER //
// src/Comprar-Rentus.vue